import compileSeat from '../compileSeat';
import compileRectangleTablePolygon from './compileRectangleTablePolygon';
import compileRectangleTableLabel from './compileRectangleTableLabel';
import compileRectangleTableCacheKey from './compileRectangleTableCacheKey';
import { MOVE_OBJECT } from '%paysera_seat_selection/js/seatSelection/config/changeSet';

function compileRectangleTable(table, changeSet) {
    let compiledTable = table;

    if (changeSet.seat !== undefined && changeSet.rectangleTable === undefined) {
        compiledTable.seats.toModelArray().forEach(seat => compileSeat(seat, changeSet));
        compiledTable = compileRectangleTableCacheKey(compiledTable);

        return compiledTable;
    }

    if (changeSet.rectangleTable && changeSet.rectangleTable.includes(MOVE_OBJECT)) {
        compiledTable.seats.toModelArray().forEach(seat => compileSeat(seat, changeSet));
        compiledTable = compileRectangleTablePolygon(compiledTable);
        compiledTable = compileRectangleTableCacheKey(compiledTable);

        return compiledTable;
    }

    compiledTable.seats.toModelArray().forEach(seat => compileSeat(seat, changeSet));
    compiledTable = compileRectangleTableLabel(compiledTable);
    compiledTable = compileRectangleTablePolygon(compiledTable);
    compiledTable = compileRectangleTableCacheKey(compiledTable);

    return compiledTable;
}

export default compileRectangleTable;
